import {
  API_ENDPOINTS,
  BUSINESS_VERTICAL_IDS,
  DEFAULT_ISD_CODE,
  DEFAULT_PLATFORM,
  PRODUCT_IDS,
  TENANT_IDS,
  VERTICAL_NAMES,
} from "./constants";

export const createVertical = (
  id,
  name,
  productId,
  tenantId,
  searchConfig,
  features,
) => {
  const vertical = {
    id,
    name,
    productId,
    tenantId,
    searchConfig,
    features: {
      call: false,
      unblock: false,
      getOtp: false,
      resetOtp: false,
      updatePassword: false,
      orderManagement: false,
      ...features,
    },

    getHeaders() {
      return {
        accept: "application/json",
        platform: DEFAULT_PLATFORM,
        "product-id": productId,
        "tenant-id": tenantId,
      };
    },

    buildSearchRequest(searchParams) {
      const headers = vertical.getHeaders();

      if (
        name === VERTICAL_NAMES.IL ||
        name === VERTICAL_NAMES.SCA ||
        name === VERTICAL_NAMES.IL_SCHOOLS
      ) {
        return {
          endpoint: API_ENDPOINTS.IL_SEARCH_USER,
          options: {
            method: "POST",
            headers,
            body: {
              phone: searchParams.phone || undefined,
              uam_id: parseInt(searchParams.uam_id) || undefined,
              admission_id: searchParams.admission_number || undefined,
            },
          },
        };
      }

      if (name === VERTICAL_NAMES.INMOBIUS) {
        const phone = searchParams.phone;

        return {
          endpoint: API_ENDPOINTS.INMOBIUS_SEARCH_USER,
          options: {
            method: "POST",
            headers,
            body: { isd_code: DEFAULT_ISD_CODE, phone },
          },
        };
      }

      const admission_number = searchParams.admission_number;

      return {
        endpoint: API_ENDPOINTS.META_SEARCH_USER(admission_number),
        options: { method: "GET", headers },
      };
    },
  };

  return vertical;
};

const VERTICALS = {
  [BUSINESS_VERTICAL_IDS.IL]: createVertical(
    BUSINESS_VERTICAL_IDS.IL,
    VERTICAL_NAMES.IL,
    PRODUCT_IDS.IL,
    TENANT_IDS.IL,
    { admission_number: false, phone: true, uam_id: true },
    {
      call: true,
      getOtp: true,
      resetOtp: true,
      orderManagement: true,
      updatePassword: false,
    },
  ),
  [BUSINESS_VERTICAL_IDS.SCA]: createVertical(
    BUSINESS_VERTICAL_IDS.SCA,
    VERTICAL_NAMES.SCA,
    PRODUCT_IDS.SCA,
    TENANT_IDS.SCA,
    { admission_number: false, phone: false, uam_id: true },
    { call: true, orderManagement: true, updatePassword: false },
  ),
  [BUSINESS_VERTICAL_IDS.META]: createVertical(
    BUSINESS_VERTICAL_IDS.META,
    VERTICAL_NAMES.META,
    PRODUCT_IDS.META,
    TENANT_IDS.META,
    { admission_number: true, phone: false, uam_id: false },
    { unblock: true, getOtp: true, resetOtp: true, updatePassword: false },
  ),
  [BUSINESS_VERTICAL_IDS.IL_SCHOOLS]: createVertical(
    BUSINESS_VERTICAL_IDS.IL_SCHOOLS,
    VERTICAL_NAMES.IL_SCHOOLS,
    PRODUCT_IDS.IL_SCHOOLS,
    TENANT_IDS.IL_SCHOOLS,
    { admission_number: true, phone: false, uam_id: false },
    { unblock: true, getOtp: true, resetOtp: true, updatePassword: true },
  ),
  [BUSINESS_VERTICAL_IDS.META_JR]: createVertical(
    BUSINESS_VERTICAL_IDS.META_JR,
    VERTICAL_NAMES.META_JR,
    PRODUCT_IDS.META_JR,
    TENANT_IDS.META_JR,
    { admission_number: true, phone: false, uam_id: false },
    { unblock: true, getOtp: true, resetOtp: true, updatePassword: false },
  ),
  [BUSINESS_VERTICAL_IDS.KHUB]: createVertical(
    BUSINESS_VERTICAL_IDS.KHUB,
    VERTICAL_NAMES.KHUB,
    PRODUCT_IDS.KHUB,
    TENANT_IDS.KHUB,
    { admission_number: true, phone: false, uam_id: false },
    { unblock: true, getOtp: true, resetOtp: true, updatePassword: false },
  ),
  [BUSINESS_VERTICAL_IDS.INMOBIUS]: createVertical(
    BUSINESS_VERTICAL_IDS.INMOBIUS,
    VERTICAL_NAMES.INMOBIUS,
    PRODUCT_IDS.INMOBIUS,
    TENANT_IDS.INMOBIUS,
    { admission_number: false, phone: true, uam_id: false },
    { getOtp: true, resetOtp: true, updatePassword: false },
  ),
};

const getVertical = (id) => VERTICALS[id];

const getVerticalByName = (name) =>
  Object.values(VERTICALS).find((vertical) => vertical.name === name);

const getAllVerticals = () => Object.values(VERTICALS);

const VerticalRegistry = {
  getVertical,
  getVerticalByName,
  getAllVerticals,
};

export default VerticalRegistry;
